/**
 * Group management module
 */

export function showAddGroupModal() {
    const modal = document.getElementById('addGroupModal');
    if (modal) {
        modal.style.display = 'flex';
        modal.classList.add('show');
    }
}

export function closeAddGroupModal() {
    const modal = document.getElementById('addGroupModal');
    if (modal) {
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 200);
    }
}

export function showAddMemberModal(groupId, groupName) {
    const groupNameDisplay = document.getElementById('groupNameDisplay');
    const addMemberForm = document.getElementById('addMemberForm');
    const modal = document.getElementById('addMemberModal');

    if (groupNameDisplay) groupNameDisplay.textContent = groupName;
    if (addMemberForm) addMemberForm.action = '/admin/groups/' + groupId + '/members/add';
    if (modal) {
        modal.style.display = 'flex';
        modal.classList.add('show');
    }
}

export function closeAddMemberModal() {
    const modal = document.getElementById('addMemberModal');
    if (modal) {
        modal.classList.remove('show');
        setTimeout(() => {
            modal.style.display = 'none';
        }, 200);
    }
}

export function toggleGroupMembers(groupId) {
    const membersDiv = document.getElementById('members-' + groupId);
    if (membersDiv) {
        membersDiv.style.display = membersDiv.style.display === 'none' ? 'block' : 'none';
    }
}

export function setupGroupModals() {
    // 문서 리스너는 한 번만 — SPA 제자리 교체로 초기화가 다시 불려도 쌓이지 않게.
    if (document.__groupModalsBound) return;
    document.__groupModalsBound = true;

    document.addEventListener('click', function(e) {
        if (e.target.classList.contains('modal-overlay')) {
            closeAddGroupModal();
            closeAddMemberModal();
        }
    });

    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeAddGroupModal();
            closeAddMemberModal();
        }
    });
}

// Make functions available globally for onclick handlers
window.showAddGroupModal = showAddGroupModal;
window.closeAddGroupModal = closeAddGroupModal;
window.showAddMemberModal = showAddMemberModal;
window.closeAddMemberModal = closeAddMemberModal;
window.toggleGroupMembers = toggleGroupMembers;
